<template>
  <div class="root">
    <!-- 这个元素是凑数用的 -->
    <div class="flex-item-placeholder"></div>

    <div class="center" @keyup.enter="onClickLoginBtn">
      <div class="title">《{{ projectName }}》管理后台</div>
      <div class="form">
        <el-form label-width="80px">
          <el-form-item label="账号">
            <el-input
              v-model="username"
              maxlength="20"
              placeholder="请输入账号"
              prefix-icon="el-icon-user"
              autofocus
            ></el-input>
          </el-form-item>
          <el-form-item label="密码">
            <el-input
              v-model="password"
              maxlength="20"
              show-password
              placeholder="请输入密码"
              prefix-icon="el-icon-lock"
            ></el-input>
          </el-form-item>
        </el-form>
        <el-button
          @click="onClickLoginBtn"
          type="primary"
          style="margin-left: 5rem"
          >登录</el-button
        >
        <!-- <el-button
          @click="onClickRegisterBtn"
          style="margin-left: 0rem; width: 9rem"
          >注册</el-button
        > -->
        <span style="margin-left: 9rem; margin-top: 1rem"
          >还没有账号？<span class="link-button" @click="onClickRegisterBtn"
            >立即注册</span
          ></span
        >
      </div>
    </div>

    <div class="footer">
      © {{ new Date().getFullYear() }} 深圳市阿飞卡科技有限公司
    </div>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
import store from "@/store";

export default {
  data() {
    return {
      projectName: "", // 项目名称
      username: "", // 用户名
      password: "", // 密码
    };
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 如果当前已经是处于登录状态了，就自动跳转到控制台首页
      let loginUser = bizutil.getLoginUser();
      if (loginUser && loginUser.isLogin == "1") {
        vm.$router.push({ name: "console" });
      }
    });
  },

  created() {
    // 取得项目名称
    this.projectName = store.projectInfo.name;

    // 从链接里取得用户名和密码（如果有的话）然后自动填入输入框
    if (this.$router.history.current.query) {
      let username = this.$router.history.current.query["username"];
      let password = this.$router.history.current.query["password"];
      if (username) {
        this.username = username;
        this.password = password;
      }
    }
  },

  methods: {
    async onClickRegisterBtn() {
      this.$dialogutil.open("RegisterDialog");
    },
    /**
     * 点击了登录按钮
     */
    async onClickLoginBtn() {
      let username = this.username.trim();
      let password = this.password.trim();
      if (username.length == 0) {
        this.$message.error("请输入有效用户名");
        return;
      }
      if (password.length == 0) {
        this.$message.error("请输入有效密码");
        return;
      }

      try {
        let resData = (
          await axios.post(`${util.getBackendApiBase()}/v1/admin/login`, {
            username: username,
            password: password,
          })
        ).data;
        if (resData.code > 0) {
          this.$message({
            message: resData.message,
            type: "error",
          });
          return;
        }

        // token
        let token = resData.data.token;

        // isNeedUpdatePassword
        let isNeedUpdatePassword = resData.data.isNeedUpdatePassword;

        // 记录登录状态
        bizutil.updateLoginUser({
          token: token,
          isLogin: "1",
          isNeedUpdatePassword: isNeedUpdatePassword,
        });

        // 紧接着，查询我的账号信息
        await bizutil.queryMyProfile();

        // 跳转到（指定的回调页面或者控制台首页）
        let redirectFullPath = this.$router.history.current.query["redirect"];
        if (!redirectFullPath) {
          return this.$router.push({ name: "console" });
        } else {
          return this.$router.push({ path: redirectFullPath });
        }
      } catch (e) {
        this.$message({
          message: e,
          type: "error",
        });
        return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.root {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.title {
  position: relative;
  top: -100px;
  font-size: 3rem;
}

.center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .form {
    width: 25rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

.link-button {
  color: rgb(37, 148, 240);
  cursor: pointer;
}
</style>